module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: _vm.headerStyle
  }, [_c('div', {
    staticClass: "row large-9 large-centered"
  }, [_c('img', {
    staticClass: "header",
    attrs: {
      "src": _vm.headerFile,
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f2bc6c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/top.vue
// module id = 707
// module chunks = 0